module.exports = __webpack_public_path__ + "static/img/merchant_feature_5.945f190.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_feature_5.png
// module id = xn5I
// module chunks = 8